import React from 'react'
import { Setters } from 'src/features/atoms/glove/japan/Components'
import { OrderPageTemplate } from 'src/Components/Domain/OrderPageTemplate'
import { catcherReducer } from 'src/features/atoms/glove/japan/slice/catcher'
import { State, PartialAction } from 'src/types'
import { useLocale } from 'src/locales/useLocale'
import { BaseModelSelector } from 'src/Components/Domain/BaseModelSelector'
import { useRouter } from 'next/router'
import { atomsBaseModel } from 'src/features/atoms/glove/japan/constants/baseModel'

const AtomsCatcher: React.FC = () => {
  const { t } = useLocale()
  const router = useRouter()
  const models = atomsBaseModel(t, router)
  const [state, dispatch] = React.useReducer(catcherReducer, t.INITIAL_STATE_C_MITT) as [State, React.Dispatch<PartialAction>]
  const [figurePanelNum, setFigurePanelNum] = React.useState(1)
  const handleFigurePanelNum = (_: any, newValue: number) => setFigurePanelNum(newValue)
  return (
    <OrderPageTemplate
      breadcrumbTrail={`${t.SOFT} / ATOMS / ${t.CATCHER}`}
      brand={'atoms'}
      {...{ figurePanelNum, state, dispatch, handleFigurePanelNum }}
    >
      <BaseModelSelector {...{ state, models, dispatch }} kinds={{ label: '軟式', value: 'soft' }} />
      <Setters {...{ state, figurePanelNum, dispatch }} />
    </OrderPageTemplate>
  )
}

export default AtomsCatcher
